// ProgramId import removed - now using string type instead
import { ComplianceGraphData, FeedbackGraphData, ProgressData } from "@domain/progress/progress-data";
import { ProgressDataService } from "@domain/progress/progress-data-service";
import { isNotNil } from "@utils/assert";
import { Map } from "immutable";
import { WritableObservable, observable } from "micro-observables";

export class ProgressDataManager {
	private readonly _progressDataByPatient = observable<Map<string, Map<string, ProgressData>>>(Map());
	private readonly _complianceGraphDataByPatient = observable<Map<string, Map<string, ComplianceGraphData>>>(Map());
	private readonly _feedbackGraphDataByPatient = observable<Map<string, Map<string, FeedbackGraphData>>>(Map());

	progressDataByPatient = this._progressDataByPatient.readOnly();
	complianceGraphDataByPatient = this._complianceGraphDataByPatient.readOnly();
	feedbackGraphDataByPatient = this._feedbackGraphDataByPatient.readOnly();

	constructor(private readonly progressDataService: ProgressDataService) {}

	async fetchProgressData(patientId: string, programId: string): Promise<void> {
		const newProgress = await this.progressDataService.loadProgressData(patientId, programId);
		this.updateMap(this._progressDataByPatient, patientId, programId, newProgress);
	}

	async fetchComplianceGraphData(patientId: string, programId: string): Promise<void> {
		const newComplianceGraphData = await this.progressDataService.loadComplianceGraphData(patientId, programId);
		this.updateMap(this._complianceGraphDataByPatient, patientId, programId, newComplianceGraphData);
	}

	async fetchFeedbackGraphData(patientId: string, programId: string): Promise<void> {
		const newFeedbackGraphData = await this.progressDataService.loadFeedbackGraphData(patientId, programId);
		this.updateMap(this._feedbackGraphDataByPatient, patientId, programId, newFeedbackGraphData);
	}

	async reset(): Promise<void> {
		this._complianceGraphDataByPatient.set(Map());
		this._feedbackGraphDataByPatient.set(Map());
		this._progressDataByPatient.set(Map());
	}

	private updateMap<T>(
		map: WritableObservable<Map<string, Map<string, T>>>,
		patientId: string,
		programId: string,
		newData: T,
	) {
		if (
			isNotNil(newData) &&
			map.get().get(patientId)?.get(programId) &&
			JSON.stringify(map.get().get(patientId)?.get(programId)) === JSON.stringify(newData)
		) {
			return;
		}
		map.update(dataMap => {
			const patientDataMap = dataMap.get(patientId) ?? Map();
			return dataMap.set(patientId, patientDataMap.set(programId, newData));
		});
	}
}
